import type { ShapeSurface, SurfaceBorder, SurfaceMaterial, SurfaceScale } from "../adapters/types";

export const SURFACE_MATERIALS: SurfaceMaterial[] = ["grass", "dirt", "sand", "gravel", "cobbles", "slabs", "deck", "chips", "concrete"];
export const SURFACE_SCALES: SurfaceScale[] = ["fine", "normal", "large"];
export const SURFACE_BORDERS: SurfaceBorder[] = ["stone", "wood", "pebbles", "fade"];

/** Les matières qui ont un habillage : l'herbe, la terre, le sable, le gravier et les copeaux. */
export const SCATTERED_MATERIALS: SurfaceMaterial[] = ["grass", "dirt", "sand", "gravel", "chips"];

export function isSurfaceBorder(value: unknown): value is SurfaceBorder {
  return SURFACE_BORDERS.includes(value as SurfaceBorder);
}

export function isSurfaceMaterial(value: unknown): value is SurfaceMaterial {
  return SURFACE_MATERIALS.includes(value as SurfaceMaterial);
}

export function isSurfaceScale(value: unknown): value is SurfaceScale {
  return SURFACE_SCALES.includes(value as SurfaceScale);
}

export function readSurface(value: unknown): ShapeSurface | undefined {
  if (!value || typeof value !== "object") return undefined;
  const { material, scale, tinted, scatter } = value as Record<string, unknown>;
  if (!isSurfaceMaterial(material)) return undefined;
  return {
    material,
    ...(isSurfaceScale(scale) && scale !== "normal" ? { scale } : {}),
    ...(tinted === true ? { tinted: true } : {}),
    ...(scatter === "light" || scatter === "dense" ? { scatter } : {}),
  };
}

export function sameSurface(a: ShapeSurface | undefined, b: ShapeSurface | undefined): boolean {
  return a?.material === b?.material && (a?.scale ?? "normal") === (b?.scale ?? "normal") && !!a?.tinted === !!b?.tinted && a?.scatter === b?.scatter;
}
